import styles from '/components/Home/Home.module.css';
import dynamic from 'next/dynamic';
import MainCarousel from "/components/MainCarousel";
import { responsive } from '/lib/services/helpers/responsive';
import style from '/styles/multi-category-home-page.module.scss'
import classes from './index.module.scss';
import { useSampleInterest } from './useSampleInterest';
const EmailModal = dynamic(() => import('/components/LaunchPage/EmailModal'));
import { useState } from 'react';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const SampleProductCollection = (props) => {
    
    const {
        heading,
        subHeading,
        productsArr,
        isMobileType,
        sku,
        campaign
    } = props;

    const [selectedSku, setSelectedSku] = useState('');
    const centerProduct = productsArr?.length < 3;

    const {
        showEmailModal,
        bSnackbarVisible,
        message,
        successMessage,
        handleSnackClose,
        setShowEmailModal,
        handleEmailClose,
        handleShareInterest,
        register,
        handleSubmit,
        errors
    } = useSampleInterest();

    const handleOpenEmailModal = (productSku) => {
        setSelectedSku(productSku);
        setShowEmailModal(true);
    };

    return (
        <>
            {bSnackbarVisible ? (
                <Snackbar
                    open={open}
                    autoHideDuration={1500}
                    onClose={handleSnackClose}
                >
                    <Alert
                        onClose={handleSnackClose}
                        severity={successMessage ? "success" : "error"}
                    >
                        {message}
                    </Alert>
                </Snackbar>
            ) : null}
            <div className='container'>
                <div className={classes.headingParent}>
                    <h1>{heading}</h1>
                    <h2>{subHeading}</h2>
                </div>

                <div className={`${centerProduct ? classes.sampleCollectionContainer : ''}`}>
                    {!isMobileType ? (
                        <div className={`${styles.sliderContainer} `}>
                            <MainCarousel
                                swipeable
                                draggable={false}
                                showDots={false}
                                responsive={responsive}
                                ssr // means to render carousel on server-side.
                                infinite
                                autoPlaySpeed={3000}
                                keyBoardControl
                                partialVisible
                                removeArrowOnDeviceType={["tablet", "mobile"]}
                                additionalTransfrom={-5}
                                itemClass={styles.carousel_item_padding}
                                minimumTouchDrag={50}
                            >
                                {productsArr?.map?.((item, index) => (<>

                                    <div key={index} className={classes.productParent}>
                                        <img src={item?.image} loading='lazy' alt={item.alt} title={item.alt} placeholder="blur" />
                                        <div className={classes.textParent}>
                                            {item?.tag ? <h6>{item?.tag}</h6> : null}
                                            {item?.subHeading ? <h4>{item?.subHeading}</h4> : null}
                                            {item?.product_title ? (
                                                <div className={classes.productTitle}>{item?.product_title}</div>
                                            ) : null}
                                            {item?.description ? (
                                                <div className={classes.productDescription}>{item?.description}</div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div
                                        className={`${classes.btn_addToCart} ${successMessage ? classes.disabled : ''}`}
                                        onClick={() => !successMessage && handleOpenEmailModal(item.product_sku)}
                                    >
                                        Add to Cart
                                    </div>
                                </>))}
                            </MainCarousel>
                        </div>
                    ) : (
                        <div className={`row ${classes.row}`}>
                            {productsArr?.map?.((item, index) => (
                                <div key={index} className={`col-9 ${classes["col-9"]}`}>
                                    <img src={item?.image} loading='lazy' alt={item?.alt} title={item?.alt} placeholder="blur" />
                                    <div className={classes.textParent}>
                                        {item?.tag ? <h6>{item?.tag}</h6> : null}
                                        {item?.subHeading ? <h4>{item?.subHeading}</h4> : null}
                                        {item?.product_title ? (
                                            <div className={classes.productTitle}>{item?.product_title}</div>
                                        ) : null}
                                        {item?.description ? (
                                            <div className={classes.productDescription}>{item?.description}</div>
                                        ) : null}
                                    </div>
                                    <div
                                        className={`${classes.btn_addToCart} ${successMessage ? classes.disabled : ''}`}
                                        onClick={() => !successMessage && handleOpenEmailModal(item.product_sku)}
                                    >
                                        Add to Cart
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <EmailModal
                showEmailModal={showEmailModal}
                handleEmailClose={handleEmailClose}
                handleShareInterest={handleShareInterest}
                register={register}
                handleSubmit={handleSubmit}
                errors={errors}
                sku={selectedSku}
                isSamplingPage={true}
                campaignName={campaign}
            />
        </>
    );
}

export default SampleProductCollection;